import React from 'react';
import PropTypes from 'prop-types';
import { useClassName } from 'common/hooks';
import { ContentfulRichText } from 'common/components';
import { LoaderImage } from '../../Loader';
import './venue-gallery.less';

const DEFAULT_TITLE = 'Gallery';

const className = useClassName('VenueGallery');

const title = (galleryTitle) => {
  if (galleryTitle) {
    return (
      <ContentfulRichText className={className('title')} field={galleryTitle} />
    );
  } else return <div className={className('title')}>{DEFAULT_TITLE}</div>;
};

const images = (images) => {
  if (!images?.length) return null;

  return images.map((image, i) => {
    return (
      <div key={i} className={className('image-container')}>
        <LoaderImage
          className={className('image')}
          src={image.file}
          alt={image.title}
          loadingHeight={260}
          fluid
        />
      </div>
    );
  });
};

const VenueGallery = ({ id, galleryTitle, gallery }) => {
  if (!gallery?.length) return null;

  return (
    <div id={id} className={className('container')}>
      {title(galleryTitle)}
      <div className={className('images-wrapper')}>{images(gallery)}</div>
    </div>
  );
};

VenueGallery.propTypes = {
  id: PropTypes.string.isRequired,
  galleryTitle: PropTypes.object,
  gallery: PropTypes.arrayOf(
    PropTypes.shape({
      file: PropTypes.string,
      title: PropTypes.string,
    })
  ).isRequired,
};

VenueGallery.defaultProps = {
  galleryTitle: null,
};

export default VenueGallery;
